import { jsx } from "react/jsx-runtime";
import { useTranslation } from "@wix/form-fields";
const StepTitleA11y = ({
  index = 0,
  total = 0
}) => {
  const { t } = useTranslation();
  const stepTitleA11y = t("form.a11y.step.index.title", {
    index: index + 1,
    total
  });
  return total > 1 ? /* @__PURE__ */ jsx("span", { "aria-label": stepTitleA11y, "aria-live": "polite" }) : null;
};
export {
  StepTitleA11y
};
//# sourceMappingURL=step-title-a11y.js.map
